<template>
<div>
  <Modal
    v-model="isShow"
    :width="900"
    :loading="loading"
    :mask-closable="false"
  >
    <h3 slot="header" class="modal-header">修改特色标签</h3>
    <Form
			ref="addData"
			:model="addData"
			:rules="ruleValidate2"
			:label-width="105"
			>
      <Row >
				<Col span="7">
					<FormItem prop="labelName" label="标签名称">
						<Input v-model="addData.labelName" placeholder="请输入不超过6个字"></Input>
					</FormItem>
				</Col>
				<Col span="7">
					<FormItem prop="labelSecondaryType" label="标签类型">
						<Select v-model="addData.labelSecondaryType" placeholder="请选择">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index1) in secondaryType" :key="'s1'+index1" :value="item.value">{{item.text}}</Option>
						</Select>
					</FormItem>
				</Col>
				<Col span="7">
					<FormItem prop="labelOrder" v-if="[1,3,4,5].indexOf(addData.labelSecondaryType)>-1" label="显示顺序">
						<Input v-model="addData.labelOrder" placeholder="请输入大于0的整数"></Input>
					</FormItem>
				</Col>
      </Row>
			<Row>
        <Col span="21">
          <FormItem label="背景图片">
            <Col style="float:left" v-if="addData.attachmentImgUrl">
              <img class="upload" :src="addData.attachmentImgUrl">
              <Button size="small" style="margin:16px 8px 0;float:left" @click="deleteImg()">删除</Button>
            </Col>
           <Upload
            class="upload"
            :action="baseUrl+'/file/uploadFile'"
            :on-success="handleSuccess"
            :headers="{'Access-Token':token}"
            :show-upload-list="false"
            :on-error="handleError"
            :format="['jpg','jpeg','png']"
            :on-format-error="formatError"
            icon="ios-cloud-upload-outline"
           >
           <Icon type="ios-plus-empty" size="30" style="vertical-align: middle"></Icon>
          </Upload>
          </FormItem>
        </Col>
      </Row>
      <Row class="max64">
        <Col span="7">
          <FormItem prop="applyType" label="适用对象">
            <Select v-model="addData.applyType" placeholder="请选择" :disabled="dis">
              <Option value=''>请选择</Option>
							<Option v-for="(item,index) in applyObject" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
						</Select>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="projectHouseTypeFids" label="适用项目/房型">
            <Select v-model="addData.projectHouseTypeFids" placeholder="请选择" multiple filterable @on-change="selectProject">
							<Option value="all" v-if="addData.applyType">全部选择</Option>
							<Option v-if="addData.applyType==2" v-for="(item,index) in houseTypes" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
							<Option v-if="addData.applyType==1" v-for="(item,index) in projects" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
						</Select>
          	<span class="count" v-if="addData.projectHouseTypeFids.length">{{addData.projectHouseTypeFids.length}}</span>
          </FormItem>
        </Col>
      </Row>
    </Form>
		<div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="ok">
        <span >保存</span>
      </Button>
    </div>
  </Modal>
	<Modal
		class="mask"
		v-model="isModalShow"
    :width="400"
    :loading="loading"
    :mask-closable="false"
		@on-ok="save"
    @on-cancel="cancel"
	>
		<h3 slot="header" class="modal-header">消息提醒</h3>
		<div class="tip">{{tips}}</div>
	</Modal>
	</div>
</template>

<script>
import {getToken} from "utils/auth";
import {getBaseUrl} from "utils/public";
import {saveOrEdit,toEditLabel} from 'api/labelmanage'

export default {
	props:{
		n:{
			type:Number,
			default:0
		},
		secondaryType:{
			type:Array,
			default(){
        return []
      }
		},
		applyObject:{
			type:Array,
			default(){
        return []
      }
		},
		houseTypes:{
			type:Array,
			default(){
        return []
      }
		},
		projects:{
			type:Array,
			default(){
        return []
      }
		},
		labelFid:{
			type:String,
			default:''
		}
	},
  data(){
		const validates = (rule, value, callback) => {
			const pattern = /^\+?[1-9]\d*$/
			if (!pattern.test(value)) {
				callback(new Error('请填写显示顺序且为大于0的整数'));
			} else {
				callback();
			}
		};
		return{
			ruleValidate2:{
				labelName:[
          { required: true, message: '请输入不超过6个字的标签名', max:6, trigger: 'blur',type:'string'}
				],
				labelSecondaryType:[
          { required: true, message: '请选择标签类型', trigger: 'change',type:'number'}
				],
        labelOrder:[
          { required: true, message: '请输入大于0的整数', trigger: 'blur',type:'number',validator: validates}
        ],
				applyType:[
					{ required: true, message: '请选择适用对象', trigger: 'change',type:'number'}
				],
				projectHouseTypeFids:[
					{ required: true, message: '请选择适用项目/房型', trigger: 'change',type:'array'}
				]
			},
			token:'',
      baseUrl:'',
			loading:false,
			isShow:false,
			addData:{
				projectHouseTypeFids:[]
			},
			isModalShow:false,
			tips:'提交后标签将在页面上显示！',
			itemP:[],
			labelEntities:[],
			maxnum:1,
			imgIndex:0,
			picUrl:[],
			selectedAll:false,
			dis:false,

		}
	},
	created() {
    this.baseUrl = getBaseUrl()
		this.token = getToken()
  },
	watch:{
		n(){
			this.getDetail();
			this.$refs['addData'].resetFields()
			this.isShow = true;

		},
		addData:{
			deep:true,
			handler(val){
				if([4,5].indexOf(val.labelSecondaryType)>-1){
					val.applyType = 1
					this.dis = true
				} else{
					this.dis = false
				}
			}
		},
	},
	methods:{
		selectProject(value){
			let isCheck = false
			value.forEach(ele=>{
				if(ele==='all'){
					isCheck = true
					this.selectedAll = !this.selectedAll
				}
			})
			if(isCheck&&this.selectedAll){
				const val = []
				if(this.addData.applyType === 1){
					this.projects.forEach(ele=>{
						val.push(ele.value)
					})
				}
				if(this.addData.applyType === 2){
					this.houseTypes.forEach(ele=>{
						val.push(ele.value)
					})
				}
				this.addData.projectHouseTypeFids = val;
			}
			if(isCheck && !this.selectedAll){
				this.addData.projectHouseTypeFids = []
			}
		},
		getDetail(){
			toEditLabel({labelFid:this.labelFid})
			.then(res=>{
				this.addData = res.data;
				if(this.addData.applyType===1){
					if(this.addData.projectHouseTypeFids.length===this.projects.length){
						this.selectedAll = true
					} else{
						this.selectedAll = false
					}
				}
				if(this.addData.applyType===2){
					if(this.addData.projectHouseTypeFids.length===this.houseTypes.length){
						this.selectedAll = true
					} else{
						this.selectedAll = false
					}
				}
			})
		},
		deleteImg(){
			this.addData.attachmentImgUrl = ''
			this.addData.attachmentFid = ''
    },
		handleSuccess(res){
			if(this.addData.attachmentImgUrl){
				this.$Message.error('最多上传'+this.maxnum+'张图片')
				this.changeLoading();
				return
			}
			this.addData.attachmentImgUrl = res.data.url;
			this.addData.attachmentFid = res.data.fid;//图片fid
		},
		formatError(){
      this.$Message.info('请上传jpg、jpeg、png类型文件')
    },
		handleError(){

    },
		deleteItem(item,index){
      this.$Modal.confirm({
        content: '<p>确认删除？</p>',
        onOk:() => {
          this.labelEntities.splice(index,1)
        }
      })
		},
		ok(){
      let validate = true
      this.$refs['addData'].validate( bool => {
        if(bool){

        } else{
          validate = false
          this.changeLoading();
        }
      })
      if (!validate) {
        this.changeLoading()
        return
			}
			this.isModalShow = true
    },
		save(){
			let picUrl = []
			if(this.addData.attachmentImgUrl){
				picUrl = [
					{
						fid:this.addData.attachmentFid,
						attachmentImgUrl:this.addData.attachmentImgUrl
					}
				]
			} else{
				picUrl = []
			}
			const labelEntities = [{
				fid:this.labelFid,
				labelType:4,
				labelName:this.addData.labelName,
				labelOrder:this.addData.labelOrder,
				labelSecondaryType:this.addData.labelSecondaryType,
				picUrl:picUrl
			}]

			const params = {
				labelEntities:labelEntities,
				applyType:this.addData.applyType,
				projectHouseTypeFids:this.addData.projectHouseTypeFids
			}
			saveOrEdit(params)
			.then(res=>{
				if(res.code === 0){
					this.$emit('done')
					this.$Message.success('保存成功')
				} else{
					// this.$Message.error('保存失败')
				}
			})
			.catch(err=>{
				// this.$Message.error('保存失败')
			})
			.finally(()=>{
				this.isModalShow = false
				this.isShow = false;
			})
		},
		cancel(){
			this.isModalShow = false
		},
		handleCancel(){
			this.isShow = false;
		},
		changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
	}
}
</script>

<style scoped>
.tip{
	font-size: 13px;
	text-align: center;
}
.upload {
    display: block;
		float: left;
    width: 60px;
    height: 40px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
		line-height: 40px;
  }
	.repeatForm{
		padding-top: 24px;
		width: 100%;
		height: auto;
		border: 1px dashed darkgrey;
		margin-bottom: 20px;
	}
.count {
    display: inline-block;
    min-width: 16px;
    min-height: 16px;
    position: absolute;
    top: -6px;
    right: -6px;
    background: #cfa868;
    color: #ffffff;
    border-radius: 100%;
    line-height: 15px;
    text-align: center;
    font-weight: 600;
  }
</style>